import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { ArrowDownIcon } from '../icons/arrow-down-icon';
import { ArrowUpIcon } from '../icons/arrow-up-icon';
import styles from './select-desktop.scss';
import Popover from '../popover';
import { POSITION } from '../../constants/positioning';
import { Button } from '../button';

const classNames = require('classnames');

export class SelectDesktop extends React.Component {
  constructor(props) {
    super(props);

    const { defaultValue } = this.props;
    this.state = {
      value: defaultValue,
      isExpanded: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({ value: nextProps.defaultValue });
    }
  }

  handleOptionClick = (option) => {
    if (this.state.value !== option.value) {
      _.invoke(this, 'props.onChange', option.value);
    }

    this.setExpanded(false);
    this.setState({ value: option.value });
  };

  getSelectedOption() {
    return _.find(this.props.options, (option) => option.value === this.state.value) || {};
  }

  setElementToFocus = (ref) => {
    this.elementToFocus = ref;
  };

  componentDidUpdate = () => {
    if (this.elementToFocus) {
      this.elementToFocus.focus();
      this.elementToFocus = undefined;
    }
  };

  setExpanded = (isExpanded) => this.setState({ isExpanded });

  renderToggle(isExpanded) {
    const { isTransparent } = this.props;
    const containerClassName = classNames(styles.box, {
      'members-default-card-background-color': !isTransparent,
    });
    const selectedOption = this.getSelectedOption();

    return (
      <div className={containerClassName}>
        <span data-hook="select-label" className={classNames(styles.label, 'select-desktop__label')}>
          {selectedOption.label}
        </span>
        {isExpanded ? (
          <ArrowUpIcon className={classNames(styles.arrow, 'ma-members-list-icon-color')} />
        ) : (
          <ArrowDownIcon className={classNames(styles.arrow, 'ma-members-list-icon-color')} />
        )}
        {isTransparent ? null : <div className={styles.borders} />}
      </div>
    );
  }

  renderItems() {
    const { options } = this.props;
    const items = _.map(options, (option, index) => {
      const isFirst = index === 0;
      const handleOptionClick = (ev) => {
        ev && ev.preventDefault();
        this.handleOptionClick(option);
      };

      return (
        <Button
          isMenuItem={true}
          dataHook="select-item"
          ref={isFirst && this.setElementToFocus}
          className={styles.option}
          key={option.value}
          onClick={handleOptionClick}
        >
          <div className={styles.hoverBackground} />
          <div className={styles.optionContent}>
            <span className={styles.label}>{option.label}</span>
          </div>
        </Button>
      );
    });

    return (
      <div data-hook="popover-content" className={styles.popoverContent}>
        {items}
      </div>
    );
  }

  render() {
    const { className, isScrollable } = this.props;
    const containerClassName = classNames(styles.container, className, {
      [styles.isScrollable]: isScrollable,
    });
    const { isExpanded } = this.state;
    return (
      <div className={containerClassName}>
        <Popover
          dataHook="selectDropDown"
          ariaLabel={this.props.ariaLabel}
          content={this.renderItems()}
          alignment={POSITION.LEFT}
          onOpen={() => this.setExpanded(true)}
          onClose={() => this.setExpanded(false)}
        >
          {this.renderToggle(isExpanded)}
        </Popover>
      </div>
    );
  }
}

SelectDesktop.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  isTransparent: PropTypes.bool,
  isScrollable: PropTypes.bool,
  ariaLabel: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ),
};

SelectDesktop.defaultProps = {
  isScrollable: true,
};

export default SelectDesktop;
